import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { BUSINESS } from "@/lib/site";
import { Breadcrumb } from "@/components/Breadcrumb";
import { ImageSlot } from "@/components/ImageSlot";
import { Reveal } from "@/components/Reveal";

export const ServiceHero = ({ h1, intro, image, breadcrumb }) => (
  <section data-testid="service-hero" className="section bg-white">
    <div className="container-site">
      <Breadcrumb items={breadcrumb} />
      <div className="mt-8 grid gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-center lg:gap-16">
        <Reveal>
          <h1 data-testid="page-heading">{h1}</h1>
          <p className="mt-6 text-lg text-body">{intro}</p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/contact" data-testid="service-hero-quote-button" className="btn btn-brand w-full sm:w-auto">
              Get My Free Quote
            </Link>
            <a href={BUSINESS.phoneHref} data-testid="service-hero-call-button" className="btn btn-outline w-full sm:w-auto">
              <Phone size={18} aria-hidden="true" />
              Call {BUSINESS.founderFirstName}
            </a>
          </div>
        </Reveal>
        <Reveal delay={60}>
          <ImageSlot label={image.id} note={image.note} ratio="3:2" alt={image.alt} priority className="rounded-card" />
        </Reveal>
      </div>
    </div>
  </section>
);
